module.exports = __webpack_public_path__ + "img/EACalculateItem4.851dcfe6.svg";